import React, { useState } from 'react'
import { Link ,useNavigate} from 'react-router-dom'
import Modal from '../Modol'
import Cart from '../Screen/Cart'
import { useCart } from './ContextReducer'







function Navbar() {

    const[cartView,setCartView]=useState(false)
    let data=useCart()

const navigate=useNavigate()

const handleLogin=()=>{
      localStorage.removeItem('token');
       navigate('/login')
}





    return (
        <div>
            <di>
                <nav className="navbar navbar-expand-lg navbar-dark bg-success">
                    <div className="container-fluid">
                        <Link className="navbar-brand fs-1 fst-italic" to="/" id='go'>GoFoodies</Link>
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarNavAltMarkup">

                            <ul className='navbar-nav me-auto mb-2'>
                                <li className='nav-item'>
                                    <Link className="nav-link active fs-5" aria-current="page" to="/">Home</Link>
                                </li>
                                {
                                    (localStorage.getItem("token")) ?
                                        <li>
                                            <Link className="nav-link active fs-5" aria-current="page" to="/order">My Order</Link>
                                        </li>
                                        : ''
                                }


                            </ul>
                            {
                                (!localStorage.getItem("token")) ?
                                    <div className='d-flex'>
                                        <Link className="btn bg-white text-success mx-1" to="/login">Login</Link>
                                        <Link className='btn bg-white text-success mx-1' to='/signup'>SignUp</Link>
                                        
                                    </div>
                                    :
                                    <div>
                                        <div className='btn bg-white text-success mx-1' onClick={()=>setCartView(true)}>
                                            My Cart {' '}
                                            <span class="badge bg-info text-danger">{data.length}</span>
                                        </div>
                                        {
                                            cartView? <Modal onClose={()=>setCartView(false)}><Cart/></Modal>:null
                                        }
                                        <div className='btn bg-white text-danger mx-1' onClick={handleLogin}>
                                            Logout

                                        </div>

                                    </div>

                            }


                        </div>
                    </div>
                </nav>
            </di>
        </div>
    )
}

export default Navbar
